import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import {Link} from 'react-router-dom';
import './style.css';

class AddDemoCategoriesQues extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
      this.catID = this.queryString.split('&c:')[1];  //participant id 
    }

    this.state={
      sub_ques : "",
      order_no :"",
      questions:"",
      selectionType : "",
      catID: this.catID,
      validationMsg: {},
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentWillMount(){

  }

  componentWillReceiveProps(nextProps){
     
    if(nextProps.demoGraphicsQuestionAddSuccess && nextProps.demoGraphicsQuestionSuccessmessage){
      alert(nextProps.demoGraphicsQuestionSuccessmessage);
      window.history.back();
      this.props.emptyDemoQuestionResponse();
    }else if(nextProps.demoGraphicsQuestionFailmessage){
      alert(nextProps.demoGraphicsQuestionFailmessage);
      this.props.emptyDemoQuestionResponse();
    }
   
  }

  onChange(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeOption(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeRadio(e){
    this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
    
    let valid = true;
    let error = {};

    if (this.state.questions === "") {
        error.questions = "Can't leave empty";
        valid = false;
    }
    if(this.state.selectionType === ""){
        error.selectionType = "Can't leave unselect";
        valid = false;
    }

    if(this.state.sub_ques === ""){
        error.sub_ques = "Can't leave unselect";
        valid = false;
    }
   
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

  saveData(){
    let quesData = {};
      if (this.handleValidation()) {
        quesData.cat_id = this.state.catID;
        quesData.orderQues = this.state.order_no;   
        quesData.questions = this.state.questions;
        quesData.selectionType = this.state.selectionType;  
        quesData.sub_ques = this.state.sub_ques 
        this.props.addQuestionDemographics(quesData);  
    }
  }

  categoryList(){
    this.props.categoryList();
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1> Add New Question</h1></div>
            <div className = "setbackbutton">
            <br/>

            {/* this.props.editCategoryPageData */}
            <Link to={{
              pathname: '/editDemographicsCategories',
              state: {
                editCategoryItemData : this.props.editCategoryPageData
              }
              }}>
            <button className = "editstudybackbtn"  >Back</button></Link>
            
            <br/>
            <div className = "studypage">

            <div style={{ color: "red", textAlign:"center" }} >{this.state.validationMsg.selectionType}</div><br/><br/>

            <label id = "addQuesLabel">Do you want to add Sub question ? </label>
            
            <input type="radio" name="sub_ques" value="true"  onChange={this.onChangeRadio} /> Yes
            <input style = {{marginLeft : "10%"}} type="radio" name="sub_ques" value="false" onChange={this.onChangeRadio} /> No
            
            <div style={{ color: "red", textAlign:"center"}} >{this.state.validationMsg.sub_ques}</div><br/><br/>

            <div>

            <label id = "lbl1">Question</label>
            <input type="text" className = "textFields" placeholder = "Enter question" name="questions" value={this.state.questions} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.questions}</div><br/>

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            
            <label id = "lbl1">Option type</label>
            <select  name="selectionType" className="selectOptionType" value={this.state.selectionType} onChange={this.onChangeOption}>
              <option value="">Select Option type</option>
              <option value="select">select</option>
              <option value="checkBox">checkBox</option>
            </select >


            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  >Create</button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>
        </div>
        </div>
    );
  }
}
export default AddDemoCategoriesQues;


// WEBPACK FOOTER //
// ./src/components/demographics/addDemoCatQuestion.js